// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.r2MaXAiYHNJpUMwPZ2j8 {
    display: flex;
    flex-direction: column;
    min-width: 0;
    width: 100%;
}

.JQYH7YGKBwKU2A8p7TZc {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    min-width: 0;
}

.CahJpS5fvJTwe9quY7ph {
    min-width: 0;
    white-space: normal;
    overflow-wrap: anywhere;
}
`, "",{"version":3,"sources":["webpack://./UiNew/components/Shared/Row/Row.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,mBAAmB;IACnB,uBAAuB;AAC3B","sourcesContent":[".flexContainer {\n    display: flex;\n    flex-direction: column;\n    min-width: 0;\n    width: 100%;\n}\n\n.value {\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    min-width: 0;\n}\n\n.valueWrap {\n    min-width: 0;\n    white-space: normal;\n    overflow-wrap: anywhere;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"flexContainer": `r2MaXAiYHNJpUMwPZ2j8`,
	"value": `JQYH7YGKBwKU2A8p7TZc`,
	"valueWrap": `CahJpS5fvJTwe9quY7ph`
};
export default ___CSS_LOADER_EXPORT___;
